import axiosBackEnd from "../config/axios/axios-back-end";

// Get All Solutions
export const getAllSolutions = async () => {
  const url = `/api/solutions`;
  const response = await axiosBackEnd.get(url);
  return response?.data;
};

// Get All Solutions
export const getDefaultIndex = async (id) => {
  const url = `/api/solutions/${id}`;
  const response = await axiosBackEnd.get(url);
  return response.data;
};

// Get Default Indexes Order Settings
export const getDefaultIndexOrderSettings = async (id) => {
  const url = `/api/solutions/${id}/default-index-order`;
  const response = await axiosBackEnd.get(url);
  return response.data;
};

// Set Default Indexes
export const setDefaultIndexes = async ({ id, data }) => {
  const url = `/api/solutions/${id}/default-index`;
  const response = await axiosBackEnd.post(url, data);
  return response.data;
};
// Set Default Indexes
export const setDefaultIndexOrderSettings = async ({ id, data }) => {
  const url = `/api/solutions/${id}/default-index-order`;
  const response = await axiosBackEnd.post(url, data);
  return response?.data;
};

export default {
  getAllSolutions,
  getDefaultIndex,
  getDefaultIndexOrderSettings,
  setDefaultIndexes,
  setDefaultIndexOrderSettings,
};
